import React from 'react';

function Title(props) {
	const {
		title = false,
		action = false
	} = props;

	if (title === false) {
		return (null);
	}

	if (action !== false && typeof action.icon === 'undefined') {
		action.icon = (null);
	}

	return (
		<div className="page-title-container">
			<div className="row">
				<div className="col-12 col-sm-6">
					<h1 className="mb-0 pb-0 display-4" id="title">{title}</h1>
					{/*<nav className="breadcrumb-container d-inline-block" aria-label="breadcrumb">
							<ul className="breadcrumb pt-0">
								<li className="breadcrumb-item"><a href="Dashboards.Default.html">Home</a></li>
								<li className="breadcrumb-item"><a href="Dashboards.html">Dashboards</a></li>
							</ul>
						</nav>*/}
				</div>

				{action && (
					<div className="col-12 col-sm-6 d-flex align-items-start justify-content-end">
						<button
							type="button"
							className="btn btn-outline-primary btn-icon btn-icon-end w-100 w-sm-auto"
							onClick={action.onClick}
						>
							<span>{action.label}</span>
							{action.icon}
						</button>
					</div>
				)}
			</div>
		</div>
	);
}

export default Title;
